import { render, staticRenderFns } from "./widget-color.vue?vue&type=template&id=14a9f54d&scoped=true"
import script from "./widget-color.vue?vue&type=script&lang=js"
export * from "./widget-color.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14a9f54d",
  null
  
)

export default component.exports